import { useState, useEffect } from 'react'

export default function useIsDesktop() {
    const [isDesktop, setIsDesktop] = useState(
        () => window.matchMedia('(min-width: 768px)').matches
    )

    useEffect(() => {
        const mql = window.matchMedia('(min-width: 768px)')
        const handler = (e) => setIsDesktop(e.matches)
        mql.addEventListener('change', handler)
        return () => mql.removeEventListener('change', handler)
    }, [])

    return isDesktop
}
